import { AxiosResponse } from 'axios';
import { axios, get, post, put } from './baseAxios';
import { ChatbotType } from '../types/chatbot.type';
import { PageRequest, PaginationResponseType } from '../types/CommonTypes';
import { ChatbotCriteria } from '../redux/models/chatbot.model';
import { API_CHATBOT } from '../utils/urls';

const url = API_CHATBOT;

const create = (request: ChatbotType): Promise<AxiosResponse<ChatbotType>> =>
  post(`${url}`, request);

const update = (id: number, request: ChatbotType): Promise<AxiosResponse<ChatbotType>> =>
  put(`${url}/${id}`, request);

const deleteById = (id: number): Promise<AxiosResponse<boolean>> => axios.delete(`${url}/${id}`);

const getById = (id: number): Promise<AxiosResponse<ChatbotType>> => get(`${url}/${id}`);

const filter = (
  request: PageRequest & ChatbotCriteria
): Promise<AxiosResponse<PaginationResponseType<ChatbotType>>> => get(`${url}`, { params: { ...request } });

export { create, deleteById, filter, getById, update };

